import { useContext } from "react";

import { CandidateNameContext,  CandidateStatusContext } from "../context";

export const useCandidateStatus = () => useContext(CandidateStatusContext)!;
export const useCandidateName = () => useContext(CandidateNameContext)!;